var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1998 8.9998C16.1998 12.9763 12.9762 16.1998 8.99979 16.1998C5.02335 16.1998 1.7998 12.9763 1.7998 8.9998C1.7998 5.02335 5.02335 1.7998 8.99979 1.7998C12.9762 1.7998 16.1998 5.02335 16.1998 8.9998ZM10.7998 6.2998C10.7998 7.29392 9.9939 8.0998 8.99979 8.0998C8.00568 8.0998 7.19979 7.29392 7.19979 6.2998C7.19979 5.30569 8.00568 4.4998 8.99979 4.4998C9.9939 4.4998 10.7998 5.30569 10.7998 6.2998ZM8.99973 9.89981C7.18394 9.89981 5.61935 10.9753 4.90816 12.524C5.89842 13.6726 7.36418 14.3998 8.99977 14.3998C10.6353 14.3998 12.1011 13.6727 13.0913 12.524C12.3802 10.9753 10.8155 9.89981 8.99973 9.89981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0bca4a5ddd9636c017fa24caec9a09fa.svg";
export { ForwardRef as ReactComponent };